import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, LOGO_URL } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-md bg-[#141417] border border-[#27272A] px-4 py-3.5 text-white placeholder-zinc-500 outline-none focus:border-[#D4AF37]";

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="ABE" className="h-12 mx-auto logo-invert" />
          <p className="font-oswald text-xs tracking-widest text-zinc-500 mt-3">RESET PASSWORD</p>
        </div>
        {sent ? (
          <div className="text-center">
            <p className="text-white">Check your inbox.</p>
            <p className="text-zinc-400 text-sm mt-2">If that email is on file, we've sent a reset link. It expires in 1 hour.</p>
            <Link to="/admin/login" className="inline-block mt-6 text-[#D4AF37] text-sm">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="forgot-email" type="email" required placeholder="Your admin email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
            <button data-testid="forgot-submit" disabled={loading} className="btn-gold w-full rounded-md py-3.5 font-oswald tracking-widest disabled:opacity-60">
              {loading ? "SENDING…" : "SEND RESET LINK"}
            </button>
            <Link to="/admin/login" className="block text-center text-xs text-zinc-500 hover:text-[#D4AF37]">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
